import type { OnInit } from '@angular/core';
import { Component } from '@angular/core';
import type {
  EnrolmentProportion,
  ProjectExperiments,
  SessionExperiments,
  UserExperiments,
} from '@freelancer/abtest';
import { ABTest } from '@freelancer/abtest';
import { firstValueFrom } from '@freelancer/utils';

@Component({
  selector: 'webapp-compat-abtest',
  template: ` <ng-container></ng-container> `,
})
export class CompatABTestComponent implements OnInit {
  constructor(private abtest: ABTest) {}

  ngOnInit() {
    const w = window as any;
    w.webappCompatABTest = {
      getSessionExperimentVariation: (name: keyof SessionExperiments) =>
        firstValueFrom(this.abtest.getSessionExperimentVariation(name)),
      getUserExperimentVariation: (
        name: keyof UserExperiments,
        userId?: number,
      ) => firstValueFrom(this.abtest.getUserExperimentVariation(name, userId)),
      getProjectExperimentVariation: (
        name: keyof ProjectExperiments,
        projectId: number,
      ) =>
        firstValueFrom(
          this.abtest.getProjectExperimentVariation(name, projectId),
        ),
      shouldEnrol: (
        name: keyof ProjectExperiments,
        contextId: number | string,
        testProportion: EnrolmentProportion,
      ) => this.abtest.shouldEnrol(name, contextId, testProportion),
    };
    if (w.webappCompatABTestReadyCallback) {
      w.webappCompatABTestReadyCallback();
    }
  }
}
